import Axios from 'axios';
import { getIdpApiBase } from './idpBase';

function buildStoreWriteBody(data) {
    if (!data) {
        return data;
    }
    return {
        storeCode: data.storeCode,
        storeName: data.storeName,
        storeLogo: data.storeLogo,
        storeBackground: data.storeBackground,
        industryType: data.industryType,
        highclass: data.highclass,
        isReserve: data.isReserve,
        isStoreCollab: data.isStoreCollab,
        pinType: data.pinType,
        pin: data.pin,
        address: data.address,
        contact: data.contact,
    };
}

export const searchStoreApi = ({
    authToken,
    deviceId,
    page,
    search,
    searchStoreCode,
    searchMerchantName,
    nRecords,
    status,
}) => {
    if (authToken != null) {
        const params = {
            storeCode: searchStoreCode || '',
            storeName: search || '',
            merchantName: searchMerchantName || '',
            page: page != null ? page : 0,
            pageSize: nRecords != null && nRecords !== '' ? Math.min(nRecords, 100) : 10,
        };
        if (status === -1 || status === 0 || status === '-1' || status === '0') {
            params.status = status;
        }
        return Axios({
            method: 'get',
            url: getIdpApiBase() + 'v2/store',
            params,
            headers: {
                authToken: authToken,
                deviceUniqueId: deviceId,
            },
        });
    }
};

export const viewStoreApi = ({ id, authToken, deviceId }) => {
    if (authToken != null && id != null) {
        return Axios({
            method: 'get',
            url: getIdpApiBase() + 'v2/store/' + id,
            headers: {
                authToken: authToken,
                deviceUniqueId: deviceId,
            },
        });
    }
};

export const createStoreApi = ({ authToken, deviceId, data }) => {
    if (authToken != null) {
        return Axios({
            method: 'post',
            url: getIdpApiBase() + 'v2/store',
            data: buildStoreWriteBody(data),
            headers: {
                'Content-Type': 'application/json',
                authToken: authToken,
                deviceUniqueId: deviceId,
            },
        });
    }
};

export const updateStoreApi = ({ authToken, deviceId, id, data }) => {
    if (authToken != null && id != null) {
        const body = buildStoreWriteBody(data);
        if (data && data.status != null) {
            body.status = data.status;
        }
        return Axios({
            method: 'put',
            url: getIdpApiBase() + 'v2/store/' + id,
            data: body,
            headers: {
                'Content-Type': 'application/json',
                authToken: authToken,
                deviceUniqueId: deviceId,
            },
        });
    }
};

export const deleteStoreApi = ({ authToken, deviceId, id }) => {
    if (authToken != null && id != null) {
        return Axios({
            method: 'delete',
            url: getIdpApiBase() + 'v2/store/' + id,
            headers: {
                authToken: authToken,
                deviceUniqueId: deviceId,
            },
        });
    }
};
